export const TOKEN_NAME_MAP = {
  AURORA: 'Aurora',
  ETH: 'Ethereum',
  NEAR: 'NEAR Protocol',
  REF: 'Ref Finance',
  SWEAT: 'Sweat Economy',
  USDC: 'USD Coin',
  'USDC.e': 'USD Coin',
  USDT: 'Tether',
  WBTC: 'Wrapped Bitcoin',
  WOO: 'WOO Network'
}

export const USDC_TOKEN_LIST = ['USDC.e']
